import { type SpaceLegacyKeys, spaceLegacy } from "./legacy/token-space";

const spaceTokensPositive = {
  sp0: 0,
  "sp0.25": 2,
  "sp0.5": 4,
  "sp0.75": 6,
  sp1: 8,
  "sp1.5": 12,
  sp2: 16,
  "sp2.5": 20,
  sp3: 24,
  sp4: 32,
  sp5: 40,
  sp6: 48,
  sp7: 56,
  sp8: 64,
  sp9: 72,
  sp10: 80,
} as const;

type SpaceTokensKeysPositive = keyof typeof spaceTokensPositive;

type NegativeSpaceTokensKeys = `-${Exclude<SpaceTokensKeysPositive, "sp0">}`;

const negativeSpaceTokens = Object.fromEntries(
  Object.entries(spaceTokensPositive)
    .filter(([k]) => k !== "sp0")
    .map(([k, v]) => [`-${k}`, -v]),
) as { [K in NegativeSpaceTokensKeys]: number };

export const spaceTokens = {
  ...spaceTokensPositive,
  ...negativeSpaceTokens,
};

export const space: typeof spaceTokensPositive &
  typeof spaceLegacy &
  typeof negativeSpaceTokens = {
  ...spaceLegacy,
  ...spaceTokensPositive,
  ...negativeSpaceTokens,
};

export type SpaceKeys =
  | SpaceTokensKeysPositive
  | NegativeSpaceTokensKeys
  | SpaceLegacyKeys;
